import { isEmpty } from 'underscore';
import { getRelativeUrl, isHubSpotUrl } from 'FormsUI/utils/UrlUtils';
import createFullUrlFromHref from 'forms-utils-lib/urls/createFullUrlFromHref';
import { isUnsafeUrl } from 'foundations-components/transitional/utils/unsafeUrl';
import { parse } from 'hub-http/helpers/params';
import { getWindowLocationSearch, getWindowLocation, getWindowHistory } from 'FormsUI/utils/WindowGetters';
export const getQueryParams = () => {
  const windowLocationSearch = getWindowLocationSearch();
  if (windowLocationSearch) {
    return parse(windowLocationSearch.slice(1).replace(/\+/g, '%20'));
  }
  return {};
};
export const getIsExternalEditorCOS = () => getQueryParams().isExternalEditor === 'cos';
export const getIsExternalEditor = () => getQueryParams().isExternalEditor !== undefined;
export const getExternalEditor = () => getQueryParams().isExternalEditor;
export const getIsDraftUpdate = () => getQueryParams().isDraftUpdate;
export const getRedirectUrl = () => {
  const queryParams = getQueryParams();
  const redirectUrl = queryParams.redirectUrl && decodeURIComponent(queryParams.redirectUrl.toString());
  const fullUrl = redirectUrl ? createFullUrlFromHref(redirectUrl) : redirectUrl;
  const isExternalUrl = !isHubSpotUrl(fullUrl);
  if (isEmpty(fullUrl) || isUnsafeUrl(fullUrl) || isExternalUrl) {
    return null;
  } else if (isHubSpotUrl(fullUrl)) {
    return getRelativeUrl(fullUrl);
  } else {
    return fullUrl;
  }
};
export const shouldShowShareDialog = () => getQueryParams().shouldShowShareDialogcreateSelector !== undefined;
export const getOpenShareModal = () => getQueryParams().openShareModal === 'true';
export const getSearchParamsPrefix = params => params.toString() ? `?${params.toString()}` : '';
export const getUpdatedSearchParams = (currentSearchParams, key, value) => {
  const searchParams = new URLSearchParams(currentSearchParams);
  searchParams.set(key, value);
  return getSearchParamsPrefix(searchParams);
};
export const getFilteredSearchParams = (currentSearchParams, paramsToRemove) => {
  const searchParams = new URLSearchParams(currentSearchParams);
  paramsToRemove.forEach(param => searchParams.delete(param));
  return getSearchParamsPrefix(searchParams);
};
export const getQueryParamValue = value => value ? value.toString() : null;
export const setQueryParam = (key, value, defaultValue = null) => {
  const url = new URL(getWindowLocation().toString());
  if (value && String(value) !== String(defaultValue)) {
    url.searchParams.set(key, String(value));
  } else {
    url.searchParams.delete(key);
  }
  getWindowHistory().replaceState({}, '', url.toString());
};
export const getIsLiveMessagesSettingsRedirectUrl = () => getQueryParams().redirectUrl.includes('live-messages-settings') || getQueryParams().redirectUrl.includes('helpdesk-settings');